import { t } from "ttag";

import type { ObjectValue } from "@/shared/models/legacy-types";

export const REFILL_REQUEST_STEP = {
  SYMPTOMS_FORM: "symptoms",
  INJECTIONS_FORM: "injections",
  FILTER_FORM: "filter",
  HEALTHIE_FORM: "healthie",
} as const;

export type RefillFormStep = ObjectValue<typeof REFILL_REQUEST_STEP>;

export const getRefillFormHeaderDescription = (step: RefillFormStep) =>
  ({
    [REFILL_REQUEST_STEP.SYMPTOMS_FORM]: t`These questions are required before further medication can be prescribed. Keep in mind that if you select any of the symptoms listed on this screen, you won't be able to continue with the LevelsRx program.`,
    [REFILL_REQUEST_STEP.INJECTIONS_FORM]: t`This question is required before further medication can be prescribed.`,
    [REFILL_REQUEST_STEP.FILTER_FORM]: t`Please spare a moment to fill out the medication refill request form. Your input is vital in facilitating a smooth and efficient refill process customized to your requirements.`,
    [REFILL_REQUEST_STEP.HEALTHIE_FORM]: t`Please spare a moment to fill out the medication refill request form. Your input is vital in facilitating a smooth and efficient refill process customized to your requirements.`,
  })[step];
